<div class="popup-container tlms-popup">
    <header>
        <div class="header" style="display:block">{{heading}}</div>
        <button class="close" style="top:-3px" (click)="close()">
            <mat-icon>close</mat-icon>
        </button>
    </header>
    <ng-container>
        <div style="padding: 16px 24px 16px 24px;">
            <div class="col-12" style="width: 100%;">
                <div class="body">
                    <div class="row">
                        <div class="col-md-6">
                            <div>
                                <label class="catlabel">Type:<span style="color:#ff0000">*</span></label>
                                <input type="text" class="content-popup" [(ngModel)]="type" [maxlength]="4"
                                    [disabled]="eventType=='EDIT'">
                            </div>
                            <div>
                                <label class="catlabel">Length:</label>
                                <input type="text" class="content-popup" [(ngModel)]="length"
                                    (keyup)="(validate($event,'weight'))" (keypress)="keyPressAlphaNumeric($event)">
                            </div>
                            <div>
                                <label class="catlabel">Height:</label>
                                <input type="text" class="content-popup" [(ngModel)]="height"
                                    (keyup)="(validate($event,'weight'))" (keypress)="keyPressAlphaNumeric($event)">
                            </div>
                            <div>
                                <label class="catlabel">Base Price:</label>
                                <input type="text" class="content-popup" [(ngModel)]="basePrice"
                                    (keyup)="(validate($event,'base_price'))" (keypress)="keyPressAlphaNumeric($event)">
                            </div>
                            <div>
                                <label class="catlabel">Country:<span style="color:#ff0000">*</span></label>
                                <input type="text" class="content-popup" [(ngModel)]="country" [maxlength]="3">
                            </div>
                            <div>
                                <label class="catlabel">Weight UOM:<span style="color:#ff0000">*</span></label>
                                <input type="text" class="content-popup" [(ngModel)]="weightUOM" [maxlength]="3">
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div>
                                <label class="catlabel">Description:<span style="color:#ff0000">*</span></label>
                                <input type="text" class="content-popup" [(ngModel)]="description">
                            </div>
                            <div>
                                <label class="catlabel">Width:</label>
                                <input type="text" class="content-popup" [(ngModel)]="width" (keyup)="(validate($event,'weight'))"
                                    (keypress)="keyPressAlphaNumeric($event)">
                            </div>
                            <div>
                                <label class="catlabel">Weight:</label>
                                <input type="text" class="content-popup" [(ngModel)]="weight"
                                    (keyup)="(validate($event,'weight'))" (keypress)="keyPressAlphaNumeric($event)">
                            </div>
                            <div>
                                <label class="catlabel">Currency:<span style="color:#ff0000">*</span></label>
                                <input type="text" class="content-popup" [(ngModel)]="currency" [maxlength]="2">
                            </div>
                            <div>
                                <label class="catlabel">Dimension:<span style="color:#ff0000">*</span></label>
                                <input type="text" class="content-popup" [(ngModel)]="dimension" [maxlength]="2">
                            </div>
                        </div>
                    </div>
                    <label *ngIf="errormsg" class="errormsg"> {{errormsg}} </label>
                </div>
            </div>
        </div>
        <div class="cfooter d-flex justify-content-between align-items-center popup-footer">
            <button (click)="onNoClick()" class="mCancel"> CANCEL
            </button>
            <button class="black-btn" style="display: inline" (click)="saveClick()">
                SAVE
            </button>
        </div>
    </ng-container>
</div>